import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-4b9b32ee-d62c-4c92-a884-61a84fcc3b63",
  "use": "icon-4b9b32ee-d62c-4c92-a884-61a84fcc3b63-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-4b9b32ee-d62c-4c92-a884-61a84fcc3b63\"><path d=\"M182.857143 0h658.285714v73.142857H182.857143z\" fill=\"#5E6E7D\" p-id=\"4840\" /><path d=\"M768 73.142857h73.142857v585.142857H768z\" fill=\"#5E6E7D\" p-id=\"4841\" /><path d=\"M402.285714 0h73.142857v146.285714H402.285714z\" fill=\"#5E6E7D\" p-id=\"4842\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol